// extracted by mini-css-extract-plugin
module.exports = {"align":"Loader_align__1GQaP","spinner":"Loader_spinner__1xokL","localLoader":"Loader_localLoader__23p6U","loaderText":"Loader_loaderText__26Ua3"};